module.exports = __webpack_public_path__ + "media/images/flags/64/Zimbabwe-c333238ed9ceeb67279d3ed070f695ff.png";